import { QuantifyState } from '@modules/quantify/store/types';
import { isEqual } from 'lodash';

interface getNewPagerNumberParams {
  oldMedataData: Partial<QuantifyState['metadata']>;
  newMedataData: Partial<QuantifyState['metadata']>;
  pageNumber: number;
}

const propsUnderInvestigation = [
  'shouldShowAllValues',
  'sortBy',
  'activeVisualisationType',
  'aggregatePeriod',
  'shouldShowCooccurringDataPoints',
  'shouldShowTopDataPoints',
  'topDataPointsSelectionCount',
  'shouldShowAnomalies',
  'anomalyThreshold',
  'shouldShowCategories',
] as const;

type PropsUnderInvestigation = typeof propsUnderInvestigation[number];

export function getNewPagerNumber({
  oldMedataData,
  newMedataData,
  pageNumber,
}: getNewPagerNumberParams) {
  const hasMismatch = Object.keys(newMedataData).some((key) => {
    const prop = key as PropsUnderInvestigation;

    if (propsUnderInvestigation.includes(prop)) {
      if (!isEqual(newMedataData[prop], oldMedataData[prop])) {
        return true;
      }
    }

    return false;
  });

  return hasMismatch ? 1 : pageNumber;
}
